export default __webpack_public_path__ + "static/media/26.a8d19785.svg";